module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-zen-3.14ac93d2.png";